import React, { useEffect } from "react";
import htmlToPdfMake from "html-to-pdfmake";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

export default function ExportChat(props) {
    const containerId = `iframeContainer-${props.chat?.id || "export"}`;

    useEffect(() => {
        let cancelled = false;
        const exportData = async () => {
            try {
                props.onProgress?.(60, "generating");
                pdfMake.vfs = pdfFonts.pdfMake.vfs;
                const html = htmlToPdfMake(props.chatMessages);
                const docDefinition = {
                    content: [html],
                };
                if (cancelled) return;
                props.onProgress?.(75, "generating");
                const pdfDocGenerator = pdfMake.createPdf(docDefinition);
                pdfDocGenerator.getDataUrl((dataUrl) => {
                    if (cancelled) return;
                    props.onProgress?.(92, "downloading");
                    const targetElement = document.querySelector(`#${containerId}`);
                    if (!targetElement) {
                        props.onError?.(new Error("Export container missing"));
                        return;
                    }
                    const anchor = document.createElement("a");
                    const downloadId = `export-group-chat-${props.chat?.id || "export"}`;
                    anchor.href = dataUrl;
                    anchor.target = "_blank";
                    anchor.setAttribute("download", `${props.chat?.name || "chat"}-chat.pdf`);
                    anchor.setAttribute("id", downloadId);
                    targetElement.appendChild(anchor);
                    document.querySelector(`#${downloadId}`).click();
                    document.querySelector(`#${downloadId}`).remove();
                    props.onProgress?.(100, "done");
                    props.onComplete?.();
                });
            } catch (error) {
                if (!cancelled) props.onError?.(error);
            }
        };
        exportData();
        return () => {
            cancelled = true;
        };
    }, []);

    return <div id={containerId} />;
}
